'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setVisibility = setVisibility;
var SET_LOADER_VISIBILITY = exports.SET_LOADER_VISIBILITY = 'SET_LOADER_VISIBILITY';

function setVisibility(visibility) {
  return {
    type: SET_LOADER_VISIBILITY,
    payload: visibility
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/LoadingContainer/actions.js
 ** module id = 96
 ** module chunks = 0
 **/